<template>
    <img :width="width" :height="height" src="/carbon-logo-dark.png" alt="">
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: '102'
        },
        height: {
            type: String,
        }
    }
}
</script>

<style scoped>
svg {
    stroke: unset !important;
}
</style>